<h2 mat-dialog-title>Seleccionar destinatario</h2>
<form class="form" (ngSubmit)="onReasignarSubmit()" [formGroup]="reasignarForm">
  <mat-dialog-content>

    <mat-form-field class="full-width">
      <mat-label>Servidor p&uacute;blico</mat-label>
      <input type="text" matInput formControlName="participante" [matAutocomplete]="autoParticipante"
        (focus)="selectAllText($event)">
      <mat-autocomplete #autoParticipante="matAutocomplete" [displayWith]="displayParticipanteFn">
        @for (participante of participantesFiltered | async; track participante) {
        <mat-option [value]="participante">
          <div><span>{{participante.apellidos +" "+ participante.nombres}}</span> </div>
          <small>{{(participante.cargo||'')+" "+participante.ciruc}} </small>
          <span class="sgd-spacer"></span>
          <mat-icon class="ultimo-uso-{{participante.fechaUso|ultimoUso}}"
            style="float: inline-end; margin-right: 0;">man</mat-icon>
        </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="full-width">
      <mat-label>Comentario</mat-label>
      <textarea matInput formControlName="comentario"></textarea>
    </mat-form-field>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button type="button" (click)="onCancel()">
      Cancelar
    </button>
    <button [disabled]="!reasignarForm.valid || loading" mat-flat-button type="submit">
      <div>
        @if (loading) {
        <mat-spinner diameter="20" color="warn"></mat-spinner>
        }@else{
        <p>Reasignar</p>
        }
      </div>
    </button>
  </mat-dialog-actions>
</form>
